import React from 'react';
import { getStatusColor, formatDate } from './helpers';

const leaveTypeLabels = {
  SICK_LEAVE: 'Sick Leave',
  ANNUAL_LEAVE: 'Annual Leave',
  UNPAID_LEAVE: 'Unpaid Leave',
};

const DayDetailsModal = ({ selectedDay, leavesData, setSelectedDay }) => (
  <div className="Leaves-modal-overlay">
    <div className="Leaves-modal-content Leaves-modal-day">
      <div className="Leaves-modal-header">
        <h2 className="Leaves-modal-title">Leaves on {formatDate(selectedDay)}</h2>
        <button 
          onClick={() => setSelectedDay(null)}
          className="Leaves-modal-close"
        >
          ✕
        </button>
      </div>
      <div className="Leaves-modal-body">
        {leavesData.filter(leave => 
          selectedDay >= leave.startDate && selectedDay <= leave.endDate
        ).length === 0 ? (
          <p className="Leaves-modal-empty">No leaves scheduled for this day</p>
        ) : (
          <div className="Leaves-day-list">
            {leavesData
              .filter(leave => selectedDay >= leave.startDate && selectedDay <= leave.endDate)
              .map(leave => (
                <div key={leave.id} className="Leaves-day-item">
                  <div className="Leaves-day-details">
                    <p className="Leaves-day-name">{leave.employee.firstName} {leave.employee.lastName} • {leave.employee.department.name}</p>
                    <p className="Leaves-day-dates">{formatDate(leave.startDate)} - {formatDate(leave.endDate)}</p>
                    <p className="Leaves-day-info" style={{gap:'10px', display:'flex'}}>
                    <span className={`Leaves-leave-type ${leave.type === 'ANNUAL_LEAVE' ? 'Leaves-leave-vacation' :
                      leave.type === 'SICK_LEAVE' ? 'Leaves-leave-sick' :
                      leave.type === 'UNPAID_LEAVE' ? 'Leaves-leave-personal' : 'Leaves-leave-default'}`}>
                      {leaveTypeLabels[leave.type] || leave.type}
                    </span>
                    <span className={`Leaves-status-badge ${getStatusColor(leave.status)}`}>
                      {leave.status}
                    </span>
                    </p>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default DayDetailsModal;